import styled from "@emotion/styled";
import BaseButton from "src/atoms/Button/BaseButton";

const StyledButton = styled(BaseButton)`
  height: 24px;
  width: 24px;

  cursor: pointer;
  border: none;
  background: none;

  &:disabled {
    cursor: default;
  }

  svg {
    height: 16px;
    width: 16px;
    fill: ${({ theme, disabled }) =>
      disabled ? theme.colors.tone.silver : theme.colors.tone.anthraciteLight};

    &:hover {
      fill: ${({ theme, disabled }) =>
        disabled ? theme.colors.tone.silver : theme.colors.tone.black};
    }
  }
`;

export { StyledButton };
